function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  padding: 0 ",
        "px;\n  @media ",
        " {\n    padding: 0 ",
        "px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  font-family: Matter, proxima-nova, -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu',\n    'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif;\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  // http://meyerweb.com/eric/tools/css/reset/\n  // v5.0.1 | 20191019\n  // License: none (public domain)\n\n  html, body, div, span, applet, object, iframe,\n  h1, h2, h3, h4, h5, h6, p, blockquote, pre,\n  a, abbr, acronym, address, big, cite, code,\n  del, dfn, em, img, ins, kbd, q, s, samp,\n  small, strike, strong, sub, sup, tt, var,\n  b, u, i, center,\n  dl, dt, dd, menu, ol, ul, li,\n  fieldset, form, label, legend,\n  table, caption, tbody, tfoot, thead, tr, th, td,\n  article, aside, canvas, details, embed,\n  figure, figcaption, footer, header, hgroup,\n  main, menu, nav, output, ruby, section, summary,\n  time, mark, audio, video {\n    margin: 0;\n    padding: 0;\n    border: 0;\n    font-size: 100%;\n    font: inherit;\n    vertical-align: baseline;\n  }\n  /* HTML5 display-role reset for older browsers */\n  article, aside, details, figcaption, figure,\n  footer, header, hgroup, main, menu, nav, section {\n    display: block;\n  }\n  /* HTML5 hidden-attribute fix for newer browsers */\n  *[hidden] {\n      display: none;\n  }\n  body {\n    line-height: 1;\n  }\n  menu, ol, ul {\n    list-style: none;\n  }\n  blockquote, q {\n    quotes: none;\n  }\n  blockquote:before, blockquote:after,\n  q:before, q:after {\n    content: '';\n    content: none;\n  }\n  table {\n    border-collapse: collapse;\n    border-spacing: 0;\n  }\n  // end css reset\n\n  html,\n  .ReactModalPortal * {\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    text-rendering: optimizeLegibility;\n    ",
        "\n  }\n\n  * {\n    box-sizing: border-box;\n  }\n\n  .ReactModal__Content {\n    outline: none;\n  }\n\n  a,\n  a:hover,\n  a:focus,\n  a:active {\n    color: #4597e0;\n    text-decoration: none;\n  }\n\n  body {\n    min-width: 320px;\n  }\n\n  /* These styles are for the Google Address lookup components */\n\n  .pac-matched {\n    font-weight: bold !important;\n  }\n  .pac-home.pac-container {\n    border: 0px;\n    border-radius: 8px;\n    position: fixed;\n    padding: 30px 38px;\n    .pac-item {\n      overflow: auto;\n    }\n    .pac-icon {\n      display: none;\n    }\n  }\n\n  .pac-container-reopened {\n    border: 1px solid #d9aeae;\n\n    &:before {\n      color: #ee6c6c;\n      font-size: 12px;\n      content: 'Please select an address below';\n      padding-top: 10px;\n      height: 22px;\n      text-align: center;\n      display: block;\n    }\n  }\n  .pac-container.modal-pac-container {\n    span {\n      font-size: 12px;\n    }\n    .pac-item {\n      overflow: hidden;\n    }\n    .pac-icon {\n      display: none;\n    }\n  }\n\n  .pac-item {\n    display: flex;\n    place-items: center;\n    height: 43px;\n    padding: 0;\n    border: 0px;\n\n    &:hover,\n    &.pac-item-selected {\n      background-color: #f5f5f5;\n      border-radius: 8px;\n      cursor: pointer;\n\n      span {\n        color: #46494c;\n      }\n    }\n\n  }\n\n  /* These styles are for the default consumer 1.0 Google Address lookup components */\n  .pac-container {\n    border: 1px solid #c2c9cc;\n    border-radius: 4px;\n    position: fixed;\n  }\n  .pac-container-reopened {\n    border: 1px solid #d9aeae;\n    &:before {\n      color: #ee6c6c;\n      font-size: 12px;\n      content: 'Please select an address below';\n      padding-top: 10px;\n      height: 22px;\n      text-align: center;\n      display: block;\n    }\n  }\n  .pac-container {\n    .pac-item {\n      height: 48px;\n      padding-top: 10px;\n      padding-left: 16px;\n      &:hover,\n      &.pac-item-selected {\n        background-color: #f5f5f5;\n        cursor: pointer;\n        span {\n          color: #46494c;\n        }\n      }\n      span {\n        color: #8f989e;\n        font-size: 13px;\n        font-weight: normal;\n        @media screen and (max-width: 800px) {\n          font-size: 11px;\n        }\n      }\n    }\n    .pac-icon {\n      display: none;\n    }\n    .pac-logo:after {\n      background-position: center;\n      border-top: 1px solid #eaeaea;\n      height: 36px;\n    }\n  }\n\n  // consumer-v1.5 google places autocomplete style override\n  .pac-home {\n    .pac-item {\n      padding: 0;\n      span {\n        color: #242526 !important;\n        font-size: 15px !important;\n        font-weight: normal;\n        @media screen and (max-width: 800px) {\n          font-size: 14px !important;\n          line-height: 43px !important;\n        }\n      }\n    }\n    .pac-icon {\n      background-image: url('/images/pin-icon.png') !important;\n      background-size: cover;\n      background-repeat: no-repeat;\n      background-position: center;\n      margin-right: 15px !important;\n      margin-left: 5px !important;\n      margin-top: 0px !important;\n      @media all and (max-width: 800px) {\n        display: none;\n      }\n    }\n    .pac-item:not(:first-of-type) {\n      margin-top: 13px;\n    }\n    @media all and (max-width: 800px) {\n      padding: 25px;\n    }\n  }\n\n  .pac-home.pac-logo {\n    ::after {\n      display: none !important;\n    }\n  }\n\n  .override-pac-container.pac-container:not(.pac-container.modal-pac-container) {\n    width: 100% !important;\n    max-width: 694px !important;\n    margin-left: -5px;\n    margin-top: 1px;\n    .pac-icon {\n      display: block;\n    }\n    @media ",
        " {\n      .pac-item {\n        overflow: scroll;\n      }\n      span {\n        font-size: 12px;\n      }\n      max-width: 322px !important;\n    }\n  }\n  .fullScreenPac.override-pac-container.pac-container:not(.pac-container.modal-pac-container) {\n    height: 100%;\n    width: 100% !important;\n    max-width: 100% !important;\n    left: 0 !important;\n    margin-top: 20px;\n    margin-left: 0;\n    border-radius: 0;\n    @media ",
        " {\n      box-shadow: 0 2px 0px rgba(0, 0, 0, 0.0408458) inset !important;\n      text-overflow: ellipsis;\n      height: fit-content;\n      overflow: auto;\n      span {\n        font-size: 14px;\n        line-height: 43px;\n      }\n      .pac-item {\n        overflow: hidden;\n        display: block;\n      }\n      .pac-icon {\n        display: none;\n      }\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
import { createGlobalStyle, css } from 'styled-components';
export var mediaSizes = {
    largeDesktop: 1200,
    desktop: 992,
    largeTablet: 960,
    tablet: 900,
    largePhone: 768,
    medium: 740,
    phone: 575,
    smallPhone: 376
};
export var mediaQueries = {
    largeDesktop: "only screen and (max-width: ".concat(mediaSizes.largeDesktop + 1, "px)"),
    desktop: "only screen and (max-width: ".concat(mediaSizes.desktop + 1, "px)"),
    largeTablet: "only screen and (max-width: ".concat(mediaSizes.largeTablet + 1, "px)"),
    tablet: "only screen and (max-width: ".concat(mediaSizes.tablet + 1, "px)"),
    largePhone: "only screen and (max-width: ".concat(mediaSizes.largePhone + 1, "px)"),
    belowMedium: "only screen and (max-width: ".concat(mediaSizes.medium - 1, "px)"),
    medium: "only screen and (min-width: ".concat(mediaSizes.medium, "px)"),
    phone: "only screen and (max-width: ".concat(mediaSizes.phone + 1, "px)"),
    smallPhone: "only screen and (max-width: ".concat(mediaSizes.smallPhone + 1, "px)"),
    iPhone5: 'only screen and (max-width: 325px)',
    custom: function(px) {
        return "only screen and (max-width: ".concat(px, "px)");
    }
};
export var colors = {
    white: '#ffffff',
    grey1: '#dedede',
    grey2: '#fcfdfe',
    grey3: '#d7dbde',
    grey4: '#5b676d',
    grey5: '#575e64',
    grey6: '#c8d0d4',
    grey7: '#8a929c',
    grey8: '#46494c',
    grey9: '#8f969c',
    grey10: '#3a3d40',
    grey11: '#777f86',
    grey12: '#c0c9cd',
    grey13: '#e2e8eb',
    grey14: '#c1c8cb',
    grey15: '#9ea7ab',
    grey16: '#b4bac0',
    grey17: '#a7aeb4',
    grey18: '#abb6bc',
    grey19: '#dbdbdb',
    grey20: '#f2f6f8',
    grey21: '#e3e6e8',
    grey22: '#dae1e6',
    greenBackground: '#f4f6f7',
    green1: '#61a58b',
    green2: '#8ecbb5',
    green3: '#c8c9c7',
    green4: '#b4c7b5',
    blue: '#4597e0',
    blueGrey: '#828A8F',
    footerBackground: '#3E566D',
    offWhite: '#f4f9ff',
    dutchiePlusBlue: {
        95: '#E5EDF6',
        45: '#586783',
        15: '#13253E',
        10: '#0C1829'
    },
    dutchiePlusGreen: {
        35: '#00BAAF'
    },
    dutchiePlusGrey: {
        95: '#DCE2FF'
    },
    dutchiePlusPurple: {
        95: '#DAE1FE',
        75: '#8298FC',
        55: '#5E6DBA',
        50: '#4756AD'
    }
};
export var variables = {
    maxWidthLarge: 1152,
    maxWidthMed: 960,
    outsidePadding: 28,
    outsidePaddingMobile: 22,
    menuTop: 94
};
export var appPadding = css(_templateObject(), variables.outsidePadding, mediaQueries.phone, variables.outsidePaddingMobile);
export var fontFamily = css(_templateObject1());
export var GlobalStyles = createGlobalStyle(_templateObject2(), fontFamily, mediaQueries.phone, mediaQueries.phone);
